/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface MFAChallengeResponse {
  mfa_challenge?: boolean;
  pending_authentication_token: string;
  authentication_challenge_id: string;
}
